import { render } from "./SeeYouSoon.vue?vue&type=template&id=7472c2a5"
const script = {}

import "./SeeYouSoon.vue?vue&type=style&index=0&id=7472c2a5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__